import type { ReactNode } from "react";
import { TimeIntervalSelect } from "./time-interval-select.content";
import { getDayTimeOptions } from "./training-schedule-form.utils";
import type { DayTemplate, HalfDay, HalfDayScheduleConfig } from "./training-schedule-form.types";

const HALF_DAYS = [
  { halfDay: "morning", label: "Matin" },
  { halfDay: "afternoon", label: "Après-midi" },
] as const satisfies readonly { halfDay: HalfDay; label: string }[];

interface DayIntervalsFieldsProps extends DayTemplate {
  onHalfDayChange: (halfDay: HalfDay, changes: Partial<HalfDayScheduleConfig>) => void;
  // Extra control rendered next to the time selects (batch forms add their speakers picker)
  renderHalfDayExtra?: (halfDay: HalfDay) => ReactNode;
}

/**
 * The morning/afternoon time selects of a single day, with their bounds already filtered.
 * Shared by the date rows and the "journée type" panel so they always offer the same choices.
 */
export const DayIntervalsFields = ({ morning, afternoon, onHalfDayChange, renderHalfDayExtra }: DayIntervalsFieldsProps) => {
  const day = { morning, afternoon };
  const options = getDayTimeOptions(day);

  return (
    <>
      {HALF_DAYS.map(({ halfDay, label }) => {
        const { enabled, start, end } = day[halfDay];

        return (
          <TimeIntervalSelect
            key={halfDay}
            label={label}
            enabled={enabled}
            startValue={start}
            endValue={end}
            startOptions={options[halfDay].start}
            endOptions={options[halfDay].end}
            onStartChange={value => onHalfDayChange(halfDay, { start: value })}
            onEndChange={value => onHalfDayChange(halfDay, { end: value })}
            onToggle={() => onHalfDayChange(halfDay, { enabled: !enabled })}
          >
            {renderHalfDayExtra?.(halfDay)}
          </TimeIntervalSelect>
        );
      })}
    </>
  );
};
